(function (ws) {
    'use strict';
    ws.views.searchEndUserTable = ws.views.simpleTable.extend({

        /**
         * Initialize override
         */
        initialize: function () {
            this.$table = this.$('#qut-search-enduser-result-table');
            this.$tableContainer = this.$('.qut-search-enduser-table');
            this.rowTemplate = this.$('#qut-search-enduser-row');
            this.endUserDetailTpl = this.$('#qut-search-enduser-details');
            this.quoteId = this.getQuoteId();
            this.$enduserField = this.$('#endUserName');
            this.$cityField = this.$('#endUserCity');
            this.$zipcodeField = this.$('#endUserZip');
            this.$accountNumberField = this.$('#endUserUId');
            this.$searchEnduserBtn = this.$('#searchEndUserBtn');
            this.$linkEnduserBtn = this.$('#qut-search-enduser-result-table td .link-end-user');
            ws.views.simpleTable.prototype.initialize.call(this);
            this.searchUrl = globals.path.api.quoting.endUserTableSearchUrl.replace('{quoteId}', this.quoteId);
            this.paginateUrl = globals.path.api.quoting.endUserTableSearchUrl.replace('{quoteId}', this.quoteId);
            this.$tableContainer.hide();
            this.$criteriaErrors = this.$('.qut-enduser-errors');
            this.$errors = this.$('.error-message');
            this.$sapErrors = this.$('.qut-endUser-sap-errors');
            this.$resetPricingEnabled = this.$('#resetPricingEnabled');
            this.city = '';
            this.endUserName = '';
            this.zipCode = '';
            this.$endUserDetailsContainer = $('.qut-endUser-span');
            this.hideErrors();
            if ($('#enableMDMTrilliumAddressValidation').val() === 'true') {
                this.responsivePriority = [
                    {responsivePriority: 1},
                    {responsivePriority: 1},
                    {responsivePriority: 1},
                    {responsivePriority: 2},
                    {responsivePriority: 2},
                    {responsivePriority: 1},
                    {responsivePriority: 1}
                ];
            } else {
                this.responsivePriority = [
                    {responsivePriority: 1},
                    {responsivePriority: 1},
                    {responsivePriority: 1},
                    {responsivePriority: 2},
                    {responsivePriority: 2},
                    {responsivePriority: 1}
                ];
            }

            this.eventAgg.on('linkEndUserAccount', this.linkEndUserAccount, this);
        },

        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'click #searchEndUserBtn': 'searchFilterCall',
            'click .select-all': 'selectAll',
            'change input[name=linkEndUser]': 'enableButton',
            'click #qut-search-enduser-result-table td .link-end-user': 'linkEndUserAccount',
            'keypress form[name=searchEndUserForm] input[type=text]': 'search'
        }),

        /**
         * A helper to hide all errors in the view
         */
        hideErrors: function () {
            this.$errors.hide();
            this.$criteriaErrors.hide();
        },

        /**
         * Getting the quoteId from the url
         */
        getQuoteId: function() {
            let url = window.location.pathname.split('/');
            return url[url.length - 1];
        },

        /**
         * Override search callback to simplify error handling
         * @param {Object} ev - Event object
         */
        search: function (ev) {
            if (ev.which === 13) {
                ev.preventDefault();
                if (ev.target.value) {
                    this.searchFilterCall();
                }
            }
        },

        /**
         * Paginate
         * @param {Object} e
         */
        paginate: function (e) {
            e.preventDefault();
            var urlParams = '';

            //if paginating on search results, use searchFilter API
            if (this.$pagination.hasClass('search')) {
                urlParams = $(e.currentTarget).attr('href');
                var page = urlParams.substring(6);
                this.searchFilter(page);
            }
        },

        /**
         * Initiate search call and save the global search values.
         */
        searchFilterCall: function () {
            this.city = this.$cityField.val();
            this.endUserName = this.$enduserField.val();
            this.zipCode = this.$zipcodeField.val();
            this.endUserUId = this.$accountNumberField.val();
            this.searchFilter();
        },
        /**
         * Search filter override
         */
        searchFilter: function (page) {
            var pageSize = this.$pageSizeInput.val();

            this.hideErrors();

            //if no default page specified and page set to event object
            if (typeof page === 'object') {
                page = '';
            }

            var request = {
                city: this.city,
                endUserName: this.endUserName,
                zipCode: this.zipCode,
                endUserUId: this.endUserUId,
                page: page,
                pageSize: pageSize
            };

            if (this.city || this.endUserName || this.zipCode || this.endUserUId) {
                this.model.url = this.searchUrl;
                this.model.set(request);

                this.$tableSpinner.show();
                this.$emtpyTableCopy.hide();

                //enable Spinner
                this.$searchEnduserBtn.addClass('spinner-before').prop('disabled', true);

                this.model.save().done(function (response) {
                    $('.search-enduser-error').text('').addClass('hide').hide();
                    this.$tableSpinner.hide();
                    this.$table.dataTable().fnClearTable();
                    this.$table.DataTable().destroy();
                    this.$searchEnduserBtn.removeClass('spinner-before').prop('disabled', false);
                    if (response.error) {
                        this.$tableContainer.hide();
                        $('.search-enduser-error').text(response.error).removeClass('hide').show();
                    } else if (response.results) {
                        this.$tableContainer.show();
                        this.$table.show();
                        this.renderRows(response.results);
                        this.calculateShowing(response.pagination);
                        this.calculatePagination(response.pagination);
                        this.$pagination.addClass('search');
                    } else {
                        this.$tableContainer.hide();
                        this.$errors.noResults.show();
                    }
                }.bind(this)).fail(function() {
                    this.$searchEnduserBtn.removeClass('spinner-before').prop('disabled', false);
                    this.tableGenericError();
                }.bind(this));
            } else {
                this.$criteriaErrors.show();
            }
        },

        /**
         * Toggle select all products
         * @param {Object} ev - Event object
         */
        selectAll: function (ev) {
            this.$('[name=preferences]').each(function (index, item) {
                item.checked = !!ev.currentTarget.checked;
            });
        },

        /**
         * Render rows override to cater for availability
         */
        renderRows: function (result) {
            var options;
            _.each(result, function (row) {
                options = {
                    model: row,
                    rowTemplate: this.rowTemplate
                };
                var tableRow = new ws.views.simpleTableRows(options);
                this.$table.append(tableRow.render().el);
            }.bind(this));

            this.initializeDataTable();
        },

        /**
         * Enable the 'Link to End user' button on click of radio button
         * @param {*} e
         */
        enableButton: function (e) {
            this.$('.link-end-user').prop('disabled', true);
            this.$sapErrors.hide();
            $(e.target).parent('td').siblings().find('.link-end-user').removeAttr('disabled');
        },

        /**
         * Link to end user on click of table button
         */
        linkEndUserAccount: function (e, sapId, trilliumResponse) {
            let quoteId = this.quoteId;
            var endUserAccountValue = e ? $(e.target).parent('td').siblings('[data-enduserid]').data('enduserid') : sapId;

            if ($('.quoteID').val() && this.$resetPricingEnabled.val() === 'true') {
                this.eventAgg.trigger('search-enduser-modalclose');
                setTimeout(() => {
                    this.eventAgg.trigger('resetQuotePricingEndUser', endUserAccountValue, trilliumResponse);
                }, 500);
            } else if ($('#enableMDMTrilliumAddressValidation').val() === 'true') {
                let url = '/quote/checkTrilliumAddress?quoteNum=' + quoteId + '&selectedAccountId=' + endUserAccountValue + '&type=ENDCUSTOMER';
                $('.trilliumPopupError').hide();
                $.get(url, (res) => {
                    if (res) {
                        this.eventAgg.trigger('search-enduser-modalclose');
                        this.eventAgg.trigger('callingSearchEndUserAPI', endUserAccountValue, 'NO_CHANGE', trilliumResponse);
                    } else {
                        $('.trilliumPopupError').show();
                    }
                });
            } else {
                this.eventAgg.trigger('search-enduser-modalclose');
                this.eventAgg.trigger('callingSearchEndUserAPI', endUserAccountValue, 'NO_CHANGE', trilliumResponse);
            }
        }
    });

})(westcon);
